import one from "../assets/svg/projects/one.svg";
import two from "../assets/svg/projects/two.svg";
import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
import five from "../assets/svg/projects/five.svg";
import six from "../assets/svg/projects/six.svg";
import seven from "../assets/svg/projects/seven.svg";
import eight from "../assets/svg/projects/eight.svg";
// import seven from "../assets/png/seven.png";
import alephbotic from "../assets/png/alephbotic.png";
import carHub from "../assets/png/car-showcase.png";
import thirteen from "../assets/svg/projects/thirteen.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "DA1 Real Estate Platform",
    projectDesc:
      "NFT-based fractional real estate investment platform enabling property tokenization and crypto transactions (ETH/USDT). Features include property browsing and investment tracking.",
    tags: ["Next.js", "Web3", "TanStack Query", "Shadcn UI"],
    code: "https://github.com/alihamzarao6",
    demo: "https://app.da1realtech.com/",
    image: one,
  },
  {
    id: 2,
    projectName: "AI Agentic Platform - Atlas Prime",
    projectDesc:
      "Backend infrastructure for AI agent orchestration system handling multiple AI service integrations and data processing workflows.",
    tags: ["Node.js", "PostgreSQL", "RESTful APIs", "Job Queues"],
    code: "https://github.com/alihamzarao6",
    demo: "https://atlasprimebr.com/",
    image: two,
  },
  {
    id: 3,
    projectName: "Artwork Marketplace - 3rdhand",
    projectDesc:
      "B2B art trading platform facilitating secure transactions between galleries and collectors. Features Stripe payment integration, real-time chat using Socket.io, and automated email notifications via cron jobs.",
    tags: ["Next.js", "Express.js", "MongoDB", "Stripe", "Socket.io"],
    code: "https://github.com/alihamzarao6",
    demo: "https://www.3rdhand.be/",
    image: three,
  },
  {
    id: 4,
    projectName: "Origins Dental Healthcare Platform",
    projectDesc:
      "Multi-location dental practice management system with appointment scheduling, patient records, and treatment tracking.",
    tags: ["Next.js", "Redux Toolkit", "Tailwind CSS"],
    code: "https://github.com/alihamzarao6",
    demo: "https://origins-dental-frontend.vercel.app/",
    image: four,
  },
   {
    id: 5,
    projectName: "Peptide Deals",
    projectDesc:
      "E-commerce platform for peptide products featuring comprehensive product catalog to advertise peptides from different companies with modern UI/UX.",
    tags: ["React.js", "Node.js", "MongoDB", "Tailwind CSS"],
    code: "https://github.com/alihamzarao6",
    demo: "https://peptidedeals.co/",
    image: five,
  },
  {
    id: 6,
    projectName: "Inventory Management Dashboard",
    projectDesc:
      "Enterprise inventory tracking system with real-time stock monitoring, analytics visualization with charts, and multi-user role management.",
    tags: ["Next.js", "Redux", "Node.js", "React Charts", "Data Visualization"],
    code: "https://github.com/alihamzarao6",
    demo: "https://inventory-management-system-wheat.vercel.app/",
    image: six,
  },
  {
    id: 7,
    projectName: "HK Sports Badminton Booking",
    projectDesc:
      "User-friendly sports facility booking system with streamlined booking flow with visual court selection interface.",
    tags: ["React.js", "Material-UI", "Responsive Design"],
    code: "https://github.com/alihamzarao6",
    demo: "https://www.hksportsbooking.com/",
    image: seven,
  },
  {
    id: 8,
    projectName: "Mark Calculator - GPA Calculator",
    projectDesc:
      "Clean, intuitive educational tool with real-time GPA calculations, local storage for data persistence across sessions, and PWA capabilities for offline functionality.",
    tags: ["React.js", "TypeScript", "PWA", "Local Storage"],
    code: "https://github.com/alihamzarao6",
    demo: "https://markcalculator.com/",
    image: eight,
  },
  {
    id: 9,
    projectName: "Alephbotic - 3D Models Platform",
    projectDesc:
      "Social platform where users can publicly share their 3D robot models. Features include profile dashboard, user interactions, and role management with proper authentication system.",
    tags: ["React.js", "Node.js", "MongoDB", "Firebase", "Tailwind CSS"],
    code: "https://github.com/alihamzarao6",
    demo: "https://alephbotic2.vercel.app/",
    image: one,
  },
  {
    id: 10,
    projectName: "Real Estate App",
    projectDesc:
      "Explore the world of real estate with our cutting-edge MERN stack app! 🚀 Powered by MongoDB, React, Express, and Node.js, this comprehensive solution seamlessly integrates the key technologies for a robust real estate platform.",
    tags: ["HTML", "CSS 3", "Java Script"],
    code: "https://github.com/alihamzarao6/ahr-real-estate",
    demo: "https://github.com/alihamzarao6/ahr-real-estate",
    // demo: "https://html-css-js-test-task.vercel.app/",
    image: four,
  },
  {
    id: 11,
    projectName: "Translator",
    projectDesc:
      "This Project is created in MERN Stack, in Backend side Authentication is created, and Speech to text, audio into text and pdf into text free rapid APIs is integrated in React Js frontend with redux Toolkit and for styling purpose tailwind css is used.",
    tags: ["MERN Stack", "Tailwaind CSS"],
    code: "https://github.com/alihamzarao6",
    demo: "https://translation-web-alpha.vercel.app/",
    image: five,
  },
  {
    id: 12,
    projectName: "CarHub",
    projectDesc:
      "CarHub is offering sale and purchase of new and used cars. The only car website which is offering cheap cars for sale. This project had just frotend.",
    tags: ["Next", "Redux", "TypeScript", "HeadlessUI"],
    code: "https://github.com/alihamzarao6",
    demo: "https://car-showcase-hub.vercel.app/",
    image: eight,
  },
  // {
  //   id: 6,
  //   projectName: "Open Sawari",
  //   projectDesc:
  //     "Ride or drive, shop or deliver, send or receive with Open Sawari — offer-your-price mobility app for fair deals. 700+. Cities. 2. billions of rides.",
  //   tags: ["Next", "React", "Tailwind", "SEO"],
  //   code: "",
  //   demo: "https://opensawari.com/",
  //   image: six,
  // },
  // {
  //   id: 2,
  //   projectName: "Mobala FX",
  //   projectDesc:
  //     "This project is about a money trasnfer web app. Its provides us the ability to exchange money internationly through people not from the banks.",
  //   tags: ["React", "Firebase", "React Bootstrap", "Redux"],
  //   code: "",
  //   demo: "https://honeymoney.hassancomputing.com/",
  //   image: two,
  // },
  // {
  //   id: 5,
  //   projectName: "Double Horse",
  //   projectDesc:
  //     "A Lubricants E-commerce application.The Company's mission is to be a leader in bringing innovative technology to the lubricant category in Pakistan.",
  //   tags: ["Wordpress"],
  //   code: "",
  //   demo: "https://doublehorse.com.pk/",
  //   image: eight,
  // },
  // {
  //   id: 9,
  //   projectName: "Bring Images to Live",
  //   projectDesc:
  //     "Convert Your Images to Reality with our Services We Make Annotations Easy and Collaborative. Connect With Local And Remote Data Sources. Experience the Speed & Ease of AI-Powered",
  //   tags: ["React", "Node", "MYSQL", "Express", "Nginx"],
  //   code: "",
  //   demo: "https://bringimagestolife.netlify.app/",
  //   image: ten,
  // },
  //   {
  //     id: 7,
  //     projectName: "Stock Market App",
  //     projectDesc: "A simple stock market API app",
  //     tags: ["React", "Redux", "Bootstrap"],
  //     code: "https://github.com/hhhrrrttt222111/developer-portfolio",
  //     demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
  //     image: seven,
  //   },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
